// src/i18n/index.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 🔹 ./locales 아래의 모든 .json을 자동으로 import
const modules = require.context('./locales', true, /\.json$/);
// ./ko/common.json → ['.', 'ko', 'common'] 이런 식으로 파싱
const resources = {};

modules.keys().forEach((key) => {
  // key 예: "./ko/common.json"
  const match = key.match(/\.\/([^/]+)\/([^/]+)\.json$/);
  if (!match) return;

  const [, lng, ns] = match; // lng = "ko", ns = "common"
  resources[lng] = resources[lng] || {};
  resources[lng][ns] = modules(key);
});

// 🔹 i18n 초기화
i18n
  .use(initReactI18next) // react-i18next 연결
  .use(LanguageDetector)
  .init({
    resources,
    // 기본 언어 (LanguageDetector 사용 시, 탐지 실패했을 때 fallback)
    fallbackLng: 'ko',
    // 사용할 네임스페이스 목록
    ns: [
      'common',
      'inquiry',
      'home',
      'beforeLogin',
      'setting',
      'date',
      'statistics',
      'menu',
      'change',
    ], //locales 파일 추가시 아이템 폴더명 추가.
    nsSeparator: ':', // ✅ setting:판매 정보 이런 문법 유지
    defaultNS: 'common',
    // keySeparator: false, // 또는 기본값 '.' 그대로 두기
    interpolation: {
      escapeValue: false, // React는 XSS 방어가 돼 있어서 false
    },

    detection: {
      // LanguageDetector 옵션 (원하면 커스터마이즈)
      // localStorage에 저장된 언어 먼저 보고 → 그다음 브라우저 언어
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
